import { render, staticRenderFns } from "./m-orm-goods-form-dialog.vue?vue&type=template&id=f3193ae8&scoped=true&lang=pug&"
import script from "./m-orm-goods-form-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-goods-form-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-goods-form-dialog.vue?vue&type=style&index=0&id=f3193ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3193ae8",
  null
  
)

export default component.exports